/**
 * @generated SignedSource<<eb86897ed1c63309d4a6173d2e0d4ae7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DeprecatedProjectIndicatorJS_project$data = {
  readonly name: string | null;
  readonly companyProjectId: number | null;
  readonly customProjectId: string | null;
  readonly projectColor: string | null;
  readonly " $fragmentType": "DeprecatedProjectIndicatorJS_project";
};
export type DeprecatedProjectIndicatorJS_project$key = {
  readonly " $data"?: DeprecatedProjectIndicatorJS_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"DeprecatedProjectIndicatorJS_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DeprecatedProjectIndicatorJS_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "companyProjectId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customProjectId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectColor",
      "storageKey": null
    }
  ],
  "type": "ProjectType",
  "abstractKey": null
};

(node as any).hash = "0c04892525d87c46f0014f37dcbc2036";

export default node;
